<template>
    <div class="row">
        <div class="col-12">{{ horario }}</div>
        <div class="col-12">
            <div v-if="status == 'EM_ANALISE'">
                <div class="mb-2">
                    <LoadingStatus :texto="'Seu atendimento está em análise'" />
                </div>
            </div>
            
            <div v-if="status == 'SEM_ORIGEM'">
                <div class="mb-2">Sem endereço de origem</div>
                <div class="text-center">
                    <BotaoUsarLocalizacao :tipoEndereco="'Origem'" />
                </div>
            </div>
            
            <div v-if="status == 'SEM_DESTINO'">
                <div class="mb-2">Sem endereço de destino</div>
                <div class="text-center">
                    <BotaoUsarLocalizacao :tipoEndereco="'Destino'" />
                </div>
            </div>

            <div v-else-if="status == 'BUSCANDO_PRESTADOR'">
                <div class="mb-1">
                    <LoadingStatus :texto="'Buscando prestador'" />
                </div>
                <div class="lh-18">
                    <small>Estamos procurando o prestador ideal para o seu atendimento</small>
                </div>
            </div>

            <div v-else-if="status == 'PRESTADOR_ACIONADO' || (temServicos && status == 'PRESTADOR_A_CAMINHO')">
                <div class="mb-1">Prestador acionado</div>
                <div class="lh-18">
                    <small>Agora é só esperar, o prestador está a caminho.</small>
                </div>
            </div>

            <div v-else-if="temServicos && 
                servico.chegadaConfirmadaPor == 'PRESTADOR' &&
                servico.solicitanteConfirmouChegada !== true && (
                    status == 'PRESTADOR_CHEGOU_LOCAL' || status == 'VIAJANDO_PARA_DESTINO' || status == 'FINALIZADO'
                )
            ">
                <div class="mb-1">Prestador chegou ao local</div>
                <div class="lh-18">
                    <small>Confirme se o prestador chegou no local de atendimento</small>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <button class="btn btn-success btn-block" @click="confirmarChegada('S')" :disabled="loading">
                            <i class="far fa-smile-beam"></i> {{ loading ? "Aguarde..." : "Chegou" }}
                        </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-danger btn-block" @click="confirmarChegada('N')" :disabled="loading">
                            <i class="far fa-frown-open"></i> {{ loading ? "Aguarde..." : "Não Chegou" }}
                        </button>
                    </div>
                </div>
            </div>

            <div v-else-if="(servico.solicitanteConfirmouChegada === true && status == 'VIAJANDO_PARA_DESTINO') || status == 'FINALIZADO'">
                <div class="mb-2">O prestador está indo para o destino</div>
            </div>

            <div v-else-if="status == 'CANCELADO'">
                <div class="mb-2">Este atendimento foi finalizado</div>
            </div>
        </div>
    </div>

</template>

<script>

import BotaoUsarLocalizacao from '@/components/Botoes/BotaoUsarLocalizacao.vue';
import LoadingStatus from '@/components/Loadings/LoadingStatus.vue';
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            loading: false,
        }
    },
    components: {
        BotaoUsarLocalizacao,
        LoadingStatus
    },
    props: {
        horario: String,
        status: String,
        servico: Object,
        idServicoAtendimento: String
    },
    computed: {
        ...mapState('Atendimento', {
            temServicos: 'temServicos',
        }),
        tempoAtualizar() {
            if (this.$func.isEmpty(this.tempoRestante)) {
                return '';
            }
            return this.tempoRestante;
        },
    },
    methods: {
        ...mapActions('Atendimento', ['enviarConfirmacaoChegada']),
        confirmarChegada(chegou) {
            this.loading = true;
            const h = this.$createElement;
            let mensagem = h('div', [
                    h('i', { class: "fa fa-exclamation-triangle text-warning mr-1" }),
                    'Deseja confirmar que o prestador ',
                    h('strong', (chegou == 'S' ? 'chegou' : 'NÃO chegou')),
                    '?',
                ]
            );

            this.$bvModal.msgBoxConfirm([mensagem], {
                okTitle: 'Enviar',
                cancelTitle: 'Cancelar',
                cancelVariant: 'outline-default',
                centered: true
            }).then(value => {
                if (value === true) {
                    this.enviarConfirmacaoChegada({
                        chegou, idServicoAtendimento: this.idServicoAtendimento
                    }).then((data) => {
                        this.$bvModal.msgBoxOk(data.message, {centered: true});
                        this.loading = false;
                    }).catch(data => {
                        this.$bvModal.msgBoxOk(data.message, {centered: true});
                        this.loading = false;
                    });
                }
            }).catch(() => {
                this.loading = false;
            });
        },        
    }
}
</script>


<style>
#icone-status-atual::before {
    content: '';
    position: absolute;
    top: 10px;
    bottom: 0;
    width: 2px;
    background: lightgray;
    left: 46%;
    z-index: -1;
}
</style>
